import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { provideReportApi } from '../../../../api/services/report.service';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';

@Component({
	template: `
		<h2 mat-dialog-title>{{ 'assignment.edit.care_title' | transloco }}</h2>
		<mat-dialog-content>
			<p>{{ 'assignment.edit.care_hint' | transloco }}</p>
		</mat-dialog-content>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				(clicked)="self.close(false)"
				icon="disabled_by_default"
			></lvr-button>
			<lvr-button
				variant="primary"
				[label]="'assignment.edit.care_change' | transloco"
				[type]="'button'"
				(clicked)="self.close(true)"
				icon="arrow_forward"
			></lvr-button>
		</mat-dialog-actions>
	`,
	imports: [MatDialogContent, MatDialogActions, MatDialogTitle, TranslocoPipe, LvrButton],
	providers: [provideReportApi],
})
export class TypeOfCareChangeDialog {
	public readonly self = inject(MatDialogRef<TypeOfCareChangeDialog>);
}
